/**
 * Created by pandemio on 3/4/19.
 */
/**
 * Created by pandemio on 2/28/19.
 */
import React from 'react';
import { Redirect } from "react-router-dom";
import { Container, FormGroup, Col, Label, Alert, Row, Button} from 'reactstrap';
/** Multiple Language imports **/
import { withLocalize } from "react-localize-redux";
import { renderToStaticMarkup } from 'react-dom/server'; // Fix by the author. Do not remove even if it's not resolved
import global from "../translations/global.json";
import { Translate } from "react-localize-redux";
/** End of Multiple Language imports **/
import LanguageManager from '../custom-classes/language-manager';
import Footer from './footer/footer';
import NavbarDesktop from './navbar/navbar-desktop-top';
import NavbarMobile from './navbar/navbar-mobile';
import Settings from '../custom-classes/settings';
import CheckoutForm from './stripe/stripe-card';
import {Elements, StripeProvider} from 'react-stripe-elements';
import NumericInput from 'react-numeric-input';
import ApiCalls from '../custom-classes/api-calls';
import LoaderFullWindow from './loader-windows/loader-full-window';
import ModalGeneric from './modals/modal-generic';
import ModalSuccess from './modals/modal-success-registration';
import FormGroupCoupon from './forms/form-coupon';
import CalculationBox from './calculation-box/calculation-box';
import LiveChat from 'react-livechat';

/**
 * The component (window) when the client acquires a new subscription
 */
class SubscriptionAddNew extends React.Component{


    constructor(props){
        // Super is always called when defining the constructor of a subclass
        // All React component classes that have a constructor, should start it with a super(props) call.
        super(props);
        // To support language library add the following lines
        this.props.initialize({
            languages: [
                { name: "English", code: "en" },
                { name: "Español", code: "es" }
            ],
            options: { renderToStaticMarkup, defaultLanguage: LanguageManager.getLanguage() }
        });
        this.props.addTranslation(global);

        this.state = {
            mobile: false,
            didMount: false,
            studentsQuantity: 1,
            stripeApiKey: Settings.getStripeToken(),
            subTokenStripe: null,
            planCostDetails: false,
            validCalculation: false,
            planAvailableForIso: true,
            planId: props.location.planId,
            subscriptionId: '',
            loading: false,
            showErrorModal: false,
            chatLiveChatLicense: Settings.CHAT_LIVE_CHAT_LICENSE
        };

        this.handleQuantityProfilesChange = this.handleQuantityProfilesChange.bind(this);
        this.submitSubscription = this.submitSubscription.bind(this);
        this.toggleAlertModal = this.toggleAlertModal.bind(this);
        this.toggleSuccessModal = this.toggleSuccessModal.bind(this);
        this.setCouponCode = this.setCouponCode.bind(this);
    }

    componentDidMount() {
        window.addEventListener("resize", this.resize.bind(this));
        this.resize();
        this.setState({didMount: true},()=>{
            this.calculateCosts();
        });
    }


    setCouponCode(e){
        this.setState({couponPlatformId: e},()=>{
            this.calculateCosts();
        });
    }

    /**
     * Toggles the success modal
     */
    toggleSuccessModal(){
        this.setState({showModalSuccess: false});
    }

    /**
     * Toogles alert modal
     */
    toggleAlertModal() {
        this.setState({showErrorModal: false});
    }


    /**
     * Submits the new subscription
     */
    submitSubscription()
    {
        if(this.state.planId === null
            || this.state.planId === "0"
            || this.state.validCalculation === false
                || this.state.planAvailableForIso === false
            || this.state.subTokenStripe === null
            || this.state.subTokenStripe.length === 0
            || this.state.studentsQuantity === 0
        ) {
            this.setState({formCompleted: false});
        }
        else
        {
            this.setState({loading:true, formCompleted: true});
            let apiCalls = ApiCalls.createSubscriptions(this.state.planId,
                this.state.studentsQuantity,
                this.state.subTokenStripe);
            apiCalls.then((data)=> {

                if(!data.TransactionValid)
                {
                    let propsModal = {
                        bodyText: data.Messages[0],
                        visible: true
                    };
                    this.setState({propsModal: propsModal, showErrorModal: true, loading: false});
                }
                else
                {
                    // Set success message
                    this.setState({subscriptionId: data.Subscriptions[0].SubscriptionId,
                        showModalSuccess: true, loading: false});
                }
            });
        }
    }

    /**
     * Set the stripe payment token
     * @param field
     */
    setStripePaymentToken = (field) => (newValue) =>{

        if(newValue == null)
            this.setState({
                subTokenStripe: null
            });
        else
        {
            this.setState({
                subTokenStripe: newValue.id
            });
        }
    };


    /**
     * Render the total details
     * @param costData
     * @returns {*}
     */
    renderTotals(costData){
        return(
            <CalculationBox costData={{costData}}/>
        );
    }


    /**
     * Calculate the costs in the service
     */
    calculateCosts(){
        if(this.state.studentsQuantity > 0)
        {
            // Calculate cost
            let apiCall = ApiCalls.getPlanTotalCosts(this.state.planId, this.state.studentsQuantity, this.state.couponPlatformId);
            apiCall.then((data)=> {
                if(data.PlanCosts !== null)
                    this.setState({validCalculation: true});
                else
                    this.setState({validCalculation: false});

                this.setState({planCostDetails: this.renderTotals(data)});
            });
        }
        else
        {
            this.setState({planCostDetails: null, validCalculation: false});
        }
    }

    /**
     * Action when the selection of quantity of student changes
     * @param e
     */
    handleQuantityProfilesChange(value) {
        this.setState({ studentsQuantity:value},()=>{
            this.calculateCosts();
        });
    }


    /**
     * To evaluate when the screen size changed
     */
    resize() {
        this.setState({mobile: window.screen.width <= 1024});
    }

    /**
     * Renders the landing page
     * @returns {XML}
     */
    render()
    {
        if(this.state.planId === null || typeof this.state.planId === 'undefined')
            return (<Redirect  to={{
                pathname: "/select-plan"
            }}/>);

        return (
            <div>
                {this.state.mobile ? <NavbarMobile/> : <NavbarDesktop/>}
                <div className="container-padding card-white">
                    <Container className="margin-top-mandatory-60">
                        <Row className="centered-text">
                            <Col xs={{size: 12}} sm={{size: 12}} md={{size: 12}} lg={{size: 12}}>
                                <h1 className="font-now-bold">
                                    <Translate id="registration-full-form.add-new-plan"/>
                                </h1>
                            </Col>
                        </Row>
                        <Row>
                            <Col style={{border: 'solid lightgray', backgroundColor: 'whitesmoke'}}
                             xs={{size:12}} sm={{size: 12}} md={{offset: 2, size: 8}} lg={{offset: 3, size: 6}}>
                                <Row className="margin-top-10">
                                    <Col xs={{size:12}} sm={{size: 12}} md={{size: 12}} lg={{size: 12}}>
                                        <div className="align-vertical-center">
                                            <h2 className="font-now-bold margin-left title">
                                                <Translate id="registration-full-form.choose-quantity"/>
                                            </h2>
                                        </div>
                                    </Col>
                                    <Col xs={{size:12}} sm={{size: 12}} md={{size: 12}} lg={{size: 12}}>
                                        <Label for="plan">
                                            <Translate id="registration-full-form.choose-quantity-instructions"/>
                                        </Label>
                                        <NumericInput
                                            defaultValue={1}
                                            onChange={this.handleQuantityProfilesChange}
                                            className="form-control" strict={true} min={1}
                                            max={5} mobile={'auto'} />
                                    </Col>
                                </Row>
                                <FormGroupCoupon updateParent={this.setCouponCode}/>
                                <hr/>
                                <Row>
                                    <Col xs={{size:12}} sm={{size: 12}} md={{size: 12}} lg={{size: 12}}>
                                        <div className="align-vertical-center">
                                            <h2 className="font-now-bold margin-left title">
                                                <Translate id="registration-full-form.credit-card-info"/>
                                            </h2>
                                        </div>
                                    </Col>

                                    <Col xs={{size:12}} sm={{size: 12}} md={{size: 12}} lg={{size: 12}}>
                                        <FormGroup row>
                                            <Col sm={{ size: 10, offset: 1 }}>
                                                <StripeProvider apiKey={this.state.stripeApiKey}>
                                                    <Elements>
                                                        <CheckoutForm data={this.state.stripeUpdatePayment}
                                                                      updateParent={this.setStripePaymentToken()} />
                                                    </Elements>
                                                </StripeProvider>
                                            </Col>
                                        </FormGroup>
                                    </Col>
                                </Row>

                                <hr/>
                                <Row>
                                    <Col xs={{size:12}} sm={{size: 12}} md={{size: 12}} lg={{size: 12}}>
                                        <FormGroup row>
                                            {this.state.planCostDetails !== null ? this.state.planCostDetails : null}
                                        </FormGroup>

                                        {!this.state.planAvailableForIso ?
                                            <FormGroup row>
                                                <Col sm={{ size: 10, offset: 1 }}>
                                                    <Alert color="danger" isOpen={!this.state.planAvailableForIso}>
                                                        <Translate id="plan-calculator-form.plan-not-available-for-your-country"/>
                                                    </Alert>
                                                </Col>
                                            </FormGroup> : null
                                        }
                                    </Col>
                                </Row>
                                <Row>
                                    <Col xs={{size:12}} sm={{size: 12}} md={{size: 12}} lg={{size: 12}}>
                                        <hr/>
                                        {
                                            !this.state.validCalculation || this.state.subTokenStripe === null
                                            || this.state.subTokenStripe === '' ?
                                                <Alert color="danger" isOpen={this.state.planAvailableForIso}>
                                                    <Translate id="register.check-fields"/>
                                                </Alert> : null
                                        }
                                        <br/>
                                        <Button block color="success" className="font-now" onClick={this.submitSubscription}>
                                            <h2>
                                                <Translate id="registration-full-form.submit-payment"/>
                                            </h2>
                                        </Button>
                                    </Col>
                                </Row>
                            </Col>
                        </Row>
                    </Container>
                    <LiveChat license={this.state.chatLiveChatLicense} />
                </div>
                {this.state.loading ? <LoaderFullWindow/> : null}
                {this.state.showErrorModal ? <ModalGeneric data={this.state.propsModal} updateParent={this.toggleAlertModal}/> : null}
                {this.state.showModalSuccess ?
                    <ModalSuccess
                        isEdit={true}
                        visible={this.state.showModalSuccess}
                        subscriptionId={this.state.subscriptionId}
                        orderNo={"ORD" + this.state.subscriptionId}
                        updateParent={this.toggleSuccessModal}/> : null}
                <Footer/>

            </div>
        )
    }

}

export default withLocalize(SubscriptionAddNew);